import React from "react";
import type { Filters, Manifest } from "../types.js";

interface Props {
  manifest: Manifest;
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
}

export function FilterPanel({ manifest, filters, setFilters }: Props) {
  return (
    <aside className="filters">
      <FacetGroup
        label="Product Category"
        values={manifest.taxonomy.productCategories}
        counts={manifest.counts.byProductCategory}
        selected={filters.productCategories}
        onToggle={(v) => setFilters((f) => toggle(f, "productCategories", v))}
      />
      <FacetGroup
        label="Region"
        values={manifest.taxonomy.regions}
        counts={manifest.counts.byRegion}
        selected={filters.regions}
        onToggle={(v) => setFilters((f) => toggle(f, "regions", v))}
      />
      <FacetGroup
        label="Asset Type"
        values={manifest.taxonomy.assetTypes}
        selected={filters.assetTypes}
        onToggle={(v) => setFilters((f) => toggle(f, "assetTypes", v))}
      />
      <FacetGroup
        label="Media"
        values={manifest.taxonomy.schemes}
        counts={manifest.counts.bySchema}
        selected={filters.schemes}
        onToggle={(v) => setFilters((f) => toggle(f, "schemes", v))}
      />
    </aside>
  );
}

function toggle<K extends keyof Filters>(f: Filters, key: K, v: string): Filters {
  if (!(f[key] instanceof Set)) return f;
  const next = new Set(f[key] as Set<string>);
  if (next.has(v)) next.delete(v);
  else next.add(v);
  return { ...f, [key]: next } as Filters;
}

function FacetGroup(props: {
  label: string;
  values: string[];
  counts?: Record<string, number>;
  selected: Set<string>;
  onToggle: (v: string) => void;
}) {
  if (props.values.length === 0) return null;
  return (
    <div className="facet">
      <h3>{props.label}</h3>
      <ul>
        {props.values.map((v) => (
          <li key={v}>
            <label>
              <input
                type="checkbox"
                checked={props.selected.has(v)}
                onChange={() => props.onToggle(v)}
              />
              <span>{v}</span>
              {props.counts?.[v] !== undefined && <em>{props.counts[v]}</em>}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
